/** @format */

import {parseEntityError} from 'frontier-form';
import {Icon} from '@sttark/design-system';
import {IfElse} from 'frontier-utilities';
import React, {useState} from 'react';
import SuperAgent from 'superagent';
import dot from 'dot-object';

export default function PushableRequestButton({
    className = '',
    role,
    requestData = {},
    endpoint = '',
    onDone = () => {},
    includeError,
    style = {},
    method = 'post',
    children,
    ...props
}) {
    const [isSending, setSending] = useState(false);
    const [error, setError] = useState();
    const [isShowing, setIsShowing] = useState(false);

    const childrenArray = React.Children.toArray(children);
    const sendingChild = childrenArray[1];
    const idleChild = childrenArray[0];

    role = typeof sendingChild === 'string' && typeof idleChild === 'string' ? 'button' : role;

    const send = async () => {
        if (props.disabled || isSending) {
            return;
        }

        setSending(true);
        setError(undefined);

        try {
            let response = {};
            const lowerMethod = method.toLowerCase();

            // Handle endpoint as function or string
            const resolvedEndpoint = typeof endpoint === 'function' ? endpoint() : endpoint;

            const request = SuperAgent(lowerMethod, resolvedEndpoint).set(
                'accept',
                'application/json'
            );

            if (lowerMethod === 'post' || lowerMethod === 'delete') {
                response = await request.send(requestData);
            } else if (lowerMethod === 'get') {
                response = await request.query(requestData);
            } else {
                throw new Error(`Unsupported method: ${method}`);
            }

            onDone(response);
        } catch (e) {
            setError(parseEntityError(e?.response?.body || {}).message);
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <div
                onClick={send}
                style={style}
                className={`${className} tw-inline-block ${
                    (props.disabled || isSending) && typeof idleChild === 'string'
                        ? 'tw-opacity-50 tw-cursor-not-allowed'
                        : 'tw-cursor-pointer'
                }`}
                role={role}
                aria-disabled={props.disabled || isSending}>
                {isSending ? sendingChild : idleChild}
            </div>

            {error && includeError && (
                <IfElse condition={isShowing}>
                    <span
                        role="button"
                        style={style}
                        className={`tw-m-2 tw-bg-yellow-500 tw-text-black tw-py-2 tw-px-4 tw-rounded tw-inline-flex tw-items-center tw-justify-center tw-cursor-pointer`}
                        onClick={setIsShowing.bind(this, false)}
                        tabIndex={0}>
                        <span className="tw-flex tw-items-center">
                            <div className="summary-warning-icon">
                                <Icon small name="warning" color="#000000" />
                            </div>
                            Hide Error
                        </span>
                    </span>
                    <span
                        role="button"
                        style={style}
                        className={`tw-m-2 tw-bg-yellow-500 tw-text-black tw-py-2 tw-px-4 tw-rounded tw-inline-flex tw-items-center tw-justify-center tw-cursor-pointer`}
                        onClick={setIsShowing.bind(this, true)}
                        tabIndex={0}>
                        <span className="tw-flex tw-items-center">
                            <Icon name="warning" small color="#000000" />
                            Show Error
                        </span>
                    </span>
                </IfElse>
            )}

            {error && isShowing && <span className="tw-text-red-600 tw-ml-2">{error}</span>}
        </>
    );
}
